export default "__VITE_ASSET__AY9RpoOP__"